import { createContext, useContext } from "react";
import { useNotifications } from "../hooks/useNotifications";

const NotificationsContext = createContext({
  badgeNotifications: [],
  dismissBadge: () => {},
  pendingRequests: [],
  updateConnectionStatus: async () => {},
});

export function NotificationsProvider({ children, userId, token }) {
  const value = useNotifications(userId, token);

  return (
    <NotificationsContext.Provider value={value}>
      {children}
    </NotificationsContext.Provider>
  );
}

export function useNotificationsContext() {
  return useContext(NotificationsContext);
}
